import {
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    useBoolean
} from '@chakra-ui/react';
import { Button, Input, Label } from '../../../../common/materials';
import { TableContainer } from '@chakra-ui/react';
import { Table, Thead, Tbody, Td, Th, Tr, Creatable } from '../../../../common/materials';
import { F1ResetPasswordResponse } from "../../../../models/authentication/F1ResetPasswordResponse";
import React from 'react';

export type ChangePasswordResponseModalProps = {
    isOpen: boolean;
    f1ResetPasswordResponse?: F1ResetPasswordResponse[];
    onClose: () => void;
};

export const ChangePasswordResponseModal = (props: ChangePasswordResponseModalProps) => {
    const { isOpen, f1ResetPasswordResponse, onClose } = props;

    const getStringBetween = (str: string, from: string, to: string): string => {
        if (!str) {
            return "";
        }

        const start = str.indexOf(from) + from.length;
        const end = str.indexOf(to, start);

        if (start < from.length || end === -1) {
            return str;
        }

        return str.slice(start, end);
    }

    return (
        <Modal
            size="6xl"
            isOpen={isOpen}
            onClose={onClose}
            scrollBehavior="outside"
        >
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Change Password Status</ModalHeader>
                <ModalCloseButton />
                <ModalBody className="flex flex-col gap-4 overflow-visible">
                    <div>
                        <TableContainer
                            className="mt-1"
                        >
                            <Table>
                                <Thead>
                                    <Tr>
                                        <Th>Company Name</Th>
                                        <Th>Status</Th>
                                        <Th>Message</Th>
                                    </Tr>
                                </Thead>
                                <Tbody>
                                    {f1ResetPasswordResponse?.map((response, index) => (
                                        <Tr className={response.status == "success" ? "": "bg-red-500"} key={response.sid}>
                                            <Td>{response.company_name}</Td>
                                            <Td>{response.status}</Td>
                                            <Td><p style={{ whiteSpace: 'pre-line' }}>{getStringBetween(response.message, 'message":"', '"').replace(/(\\r\\n|\\n|\\r)/g, '\n')}</p></Td>
                                        </Tr>
                                    ))}
                                </Tbody>
                            </Table>
                        </TableContainer>
                    </div>
                </ModalBody>
                <ModalFooter className="gap-4">
                    <Button
                        outline
                        size="sm"
                        className="text-gray-400"
                        onClick={onClose}
                    >
                        Cancel
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
}